import React, { useEffect, useRef, useState } from "react";
import {
  query,
  collection,
  orderBy,
  onSnapshot,
  limit,
  where,
} from "firebase/firestore";
import { auth, db } from "../firebase";
import Message from "./Message";
import SendMessage from "./SendMessage";
import { UserChatHistoryType, UserType } from "../utils/types";
import { fetchChatHistory, updateChatHistory } from "./ChatUtil";

interface ChatBoxProps {
  toUser: UserType;
}

const ChatBox = (props: ChatBoxProps) => {
  const [messages, setMessages] = useState<any[]>([]);
  const [chatHistory, setChatHistory] = useState<UserChatHistoryType[]>([]);
  const scroll = useRef<HTMLSpanElement>(null);
  // we should create unique chatId, which will include both user ids for better search
  const users = [auth.currentUser?.uid ?? "", props.toUser.id];
  const chatId = users.sort((a, b) => a.localeCompare(b)).join("");

  const q = query(
    collection(db, "messages"),
    where("chatId", "==", chatId),
    orderBy("createdAt", "desc"),
    limit(50)
  );

  useEffect(() => {
    if (auth?.currentUser)
      fetchChatHistory(chatId, auth.currentUser.uid, setChatHistory);

    const unsubscribe = onSnapshot(q, (QuerySnapshot) => {
      const fetchedMessages: any[] = [];
      QuerySnapshot.forEach((doc: any) => {
        fetchedMessages.push({
          ...doc.data(),
          id: doc.id,
          createdAt: new Date(doc.data().createdAt),
        });
      });
      const sortedMessages = fetchedMessages.sort(
        (a, b) => a.createdAt - b.createdAt
      );
      setMessages(sortedMessages);
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    scroll.current?.scrollIntoView({ behavior: "smooth" });

    // if messages where updated, let's save history in the chat
    if (auth.currentUser && chatHistory[0]) {
      console.log(2);
      updateChatHistory(chatId, auth.currentUser.uid, chatHistory[0].id);
    }
  }, [messages]);

  return (
    <main className="chat-box">
      <div className="messages-wrapper">
        {messages?.map((message) => (
          <Message key={message.id} message={message} />
        ))}
        <span ref={scroll}></span>
      </div>
      {/* when a new message enters the chat, the screen scrolls down to the scroll div */}
      <SendMessage userId={props.toUser.id} chatId={chatId} />
    </main>
  );
};

export default ChatBox;
